module.exports = __webpack_public_path__ + "img/bannerRed.4c47ead3.jpg";